module.exports = __webpack_public_path__ + "img/section_1-svg_3.a46ce86b.svg";